import { render, staticRenderFns } from "./Activity.vue?vue&type=template&id=8c2dc70e&scoped=true"
import script from "./Activity.vue?vue&type=script&lang=js"
export * from "./Activity.vue?vue&type=script&lang=js"
import style0 from "./Activity.vue?vue&type=style&index=0&id=8c2dc70e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2dc70e",
  null
  
)

export default component.exports